<template>
	<div>
		<Confirm ref="confirm" @confirm="del"></Confirm>
		<WatchSystem ref="watchSystem"></WatchSystem>
		<ChooseStation ref="ChooseStation" @openView="openview"></ChooseStation>
		<Window ref="Window" @Close="myClose" :bg="bg">
			<!-- 头部开始 -->
			<div
				slot="headButton"
				class="dpIB fSub_E hover-f-main_E tra-fast_E"
			>
				<button
					v-permissions="'B/A/A2'"
					permission-type="none"
					:title="getLanguageStr('cmd200', '查看所属系统')"
					type="button"
					@click="showStation(device)"
				>
					<Icon name="link" class="w1x h1x" :sizeBase="'m'" />
				</button>
				<button
					:title="$t('word781', ['控制'])"
					v-permissions="'B/A/A3'"
					permission-type="none"
					type="button"
					@click="deviceControl(device)"
				>
					<Icon name="ctrl" class="w1x h1x" :sizeBase="'m'" />
				</button>
				<button
					:title="$t('cmd21', ['升级'])"
					v-permissions="'B/A/A4'"
					onclick="statistic('A70','A7001')"
					permission-type="none"
					type="button"
					@click="deviceUpgrade(device)"
				>
					<Icon name="upgrade" class="w1x h1x" :sizeBase="'m'" />
				</button>
				<button
					v-if="
						doPermissions('B/A/A11', {
							targetCode: 'A6',
							codeList: option.outRoleCode,
						})
					"
					:title="$t('cmd9', ['删除'])"
					v-permissions="'B/A/A11'"
					permission-type="none"
					type="button"
					@click="deletes(device, instance, $refs.Window)"
				>
					<Icon name="trash" class="w1x h1x" :sizeBase="'m'" />
				</button>
				<button
					:title="$t('cmd7', ['刷新'])"
					type="button"
					@click="refresh"
				>
					<Icon name="refresh" class="w1x h1x" :sizeBase="'m'" />
				</button>
			</div>
			<div slot="head" class="cb">
				<div class="">
					<div>
						<div class="dpIB vaM fs14x">
							{{
								showName
									? showName + ":"
									: getTypeText(
											deviceDetail.type || "",
											"deviceType"
									  ) + ":"
							}}{{ deviceDetail.deviceSn }}
						</div>
					</div>
					<div class="posR mt1x">
						<div class="dpIB_E dpIB fs12x">
							<div class="mr1x">
								<span v-if="deviceDetail.deviceState == null"
									>--</span
								>
								<StatusIco
									v-else
									:id="deviceDetail.deviceState"
									:type="'device'"
									class="statueIcon fs08x"
								></StatusIco>
								<span v-if="deviceDetail.deviceState != null">{{
									getTypeText(
										deviceDetail.deviceState,
										"deviceState"
									)
								}}</span>
							</div>
						</div>
						<div class="fR">
							<span v-if="deviceDetail.collectionTime">{{
								timeFormat(
									deviceDetail.collectionTime,
									"utc",
									"%Y/%m/%d %H:%M:%S UTC",
									{ offset: deviceDetail.timeZone }
								)
							}}</span>
						</div>
					</div>
				</div>
			</div>
			<!-- 头部结束end -->
			<div>
				<div class="navBtn pl1x bdSub-bottom-notLast">
					<div
						class="tabBar style-tabBar cb active-c-main_E tra-fast_E"
					>
						<button
							v-for="(item, index) in btnGroup"
							:key="index"
							class="cSub afterButton"
							:class="{ active: index == currentIndex }"
							@click="changeBtn(index)"
						>
							{{ item.title }}
						</button>
					</div>
				</div>
				<Detail
					v-if="btnGroup[currentIndex].ref == 'Details'"
					ref="Details"
					:deviceDetail="deviceDetail"
				></Detail>
				<AlarmInfo
					:userFor="'device'"
					v-if="btnGroup[currentIndex].ref == 'AlarmInfo'"
					:startTime="deviceDetail.collectionTime"
					:type="2"
					:timezone="deviceDetail.timeZone || option.timeZoneCode"
					:deviceIdList="[deviceId]"
					:productId="deviceDetail.productId"
					:alarmObjSelect="false"
					ref="AlarmInfo"
				></AlarmInfo>
				<div
					v-show="btnGroup[currentIndex].ref == 'LinkInfo'"
					ref="linkInfoBox"
				></div>
				<!-- <LinkInfo v-if="btnGroup[currentIndex].ref=='LinkInfo'" :type="type" :timezone="deviceDetail.timeZone||option.timeZoneCode" :siteId="siteId" :deviceId="deviceId" :deviceSn="deviceSn" ref="LinkInfo"></LinkInfo> -->
				<OperateRecord
					v-if="btnGroup[currentIndex].ref == 'OperateRecord'"
					ref="OperateRecords"
					:tabindex="tabindex"
					:timezone="deviceDetail.timeZone || option.timeZoneCode"
					:deviceType="device.deviceType || deviceType"
					:deviceId="deviceId"
					:deviceSn="deviceSn"
				></OperateRecord>
				<!-- <ReaderRecord v-if="btnGroup[currentIndex].ref=='ReaderRecord'" :timezone="deviceDetail.timeZone||option.timeZoneCode" :deviceId="deviceId" :deviceSn="deviceSn" ref="ReaderRecord"></ReaderRecord>
			<UpdateRecord v-if="btnGroup[currentIndex].ref=='UpdateRecord'" :timezone="deviceDetail.timeZone||option.timeZoneCode" :deviceId="deviceId" :deviceSn="deviceSn" ref="UpdateRecord"></UpdateRecord> -->
			</div>
		</Window>
		<div ref="view"></div>
	</div>
</template>
<script>
import {mapMutations} from 'vuex';
import * as lib from '@/util/lib';
import SiteDetail from '@/view/maintain/light/plant/ViewDetail.vue';
import Window from '@/components/common/ui/WindowForView.vue';
import Loading from '@/components/common/ui/Loading';
import NoResult from '@/components/common/ui/NoResult';
import StatusIco from '@/components/common/ui/StatusIco';
import ChooseStation from '@/view/device/device/part/ChooseStation.vue';
// import PlantDetail from '@/view/maintain/light/plant/ViewDetail.vue';
import Detail from '@/view/device/device/part/Detail.vue'; // 详情
import AlarmInfo from '@/view/maintain/alarm/part/List'; // 报警信息
import LinkInfo from '@/view/device/device/part/LinkInfo'; // 连接信息
import ReaderRecord from '@/view/device/device/part/ReaderRecord'; // 控制记录
import UpdateRecord from '@/view/device/device/part/UpdateRecord'; // 升级记录
import OperateRecord from '@/view/device/device/part/OperateRecord'; // 控制记录
import DeviceControl from '@/view/device/device/DeviceControl.vue';
import DeviceUpgrade from '@/view/device/device/DeviceUpgrade.vue';
import Confirm from '@/components/common/ui/Confirm.vue';
import * as maintainApi from '@/api/maintain/plant/list';
import {autoAssociate, deleteDevice} from '@/api/device/device/device.js';
import * as deviceApi from '@/api/device/list';
import {OperationDelete} from '@/api/maintain/plant/list';
import {productInstructionsCheck} from '@/api/product/index.js';
import {apiGetAvailableOrder} from '@/api/device/order';
// import {apiOpenStatus} from '@/api/device/order';
import {orderFirmwareListCode} from '@/api/device/firmware';
import WindSiteDetail from '@/view/maintain/wind/plant/ViewDetail.vue';
import WatchSystem from "@/view/device/device/part/WatchSystem.vue";
export default {
	name: 'deviceDetailCommon',
	components: {
		Confirm,
		Loading,
		NoResult,
		Window,
		StatusIco,
		Detail,
		AlarmInfo,
		// LinkInfo,
		ReaderRecord,
		UpdateRecord,
		OperateRecord,
		ChooseStation,
		WatchSystem,
	},
	props: {
		type: {
			// 1:电站；2:设备
			type: Number,
			default: 2
		},
		bg: {
			// 是否显示遮罩背景
			type: Boolean,
			default: false
		},
		timezone: {
			type: String,
			default: stage.time.timeZoneCode
		},
		outRoleCode: {
			// 外部权限列表
			type: Array,
			default: null
		}
	},
	data () {
		return {
			window: window,
			dynamic: {}, // 存储动态组件
			option: {
				timeZoneCode: this.timezone,
				outRoleCode: this.outRoleCode // 外部权限列表
			},
			headInfo: [],
			siteId: '',
			deviceId: '',
			deviceSn: '',
			device: {},
			deviceDetail: {}, // 设备详情
			isEmpty: true,
			btnGroup: [{ref: 'detail'}],
			instance: '',
			deviceType: lib.getTypeText('', 'deviceType', true)[0].id[0],
			currentIndex: 0,
			tabindex: '',
			showName: '',
			canBeClick: true,
			viewDetailOpen: false
		};
	},
	watch: {
		outRoleCode: function (data) {
			this.option.outRoleCode = data;
		},
		_route: function (nUrl, oUrl) {
			if (nUrl != oUrl) {
				this.hide();
			}
		}
	},
	computed: {
		// ...mapGetters({
		//   currentIndex: 'deviceDetail/currentIndex'
		// })
	},
	methods: {
		...mapMutations({
			SET_CURRENTINDEX: 'deviceDetail/SET_CURRENTINDEX'
		}),
		getLanguageStr,
		getTypeText: lib.getTypeText,
		timeFormat: lib.timeFormat,
		doPermissions: lib.doPermissions,
		deletes (device, instance, w) {
			if (instance) {
				this.delinstance = {instance, w};
			}

			if (this.type == 1) {
				// 仅可删除电站内的设备
				this.$refs.confirm.show({
					text: getLanguageStr(
						'plant274',
						'确定要将该设备从电站中删除吗?'
					),
					yes: () => {
						this.$refs.Window.loadStatusAction(true);
						OperationDelete(this.device.systemId, [
							this.device.id
						]).then(
							(res) => {
								this.$emit('Delete');
								this.hide();
							},
							(error) => {
								this.$refs.Window.loadStatusAction(false);
								!_.isEmpty(error) && this.$notify(error);
							}
						);
					}
				});
			} else if (
				device.deviceType === 'COLLECTOR' ||
				device.deviceType === 'DTU'
			) {
				this.$refs.confirm.show({
					text: getLanguageStr(
						'phrase719',
						'删除该网关/采集器后，子设备将同步删除，确认要删除该设备吗？'
					),
					ids: device
				});
			} else {
				// 设备板块不支持删除非网关设备
				this.$notify(
					getLanguageStr('phrase718', '暂不支持删除非网关类设备')
				);
			}
		},

		del (ids) {
			let data = {
				delList: [
					{deviceType: ids.ids.deviceType, sn: ids.ids.deviceSn}
				],
				deviceType: 'COLLECTOR',
				language: stage.languageId
			};
			// lib.loadingChange($('.tableScope [loading]'), 'true')
			let $this = this;
			deleteDevice(data)
				.then((_) => {
					if (
						this.nowpageTot === 1 &&
						this.pagination.request.page !== 1
					) {
						this.pagination.request.page -= 1;
					}
					// this.getList()

					if (this.delinstance) {
						this.delinstance.w.hide();
						setTimeout(() => {
							$this.$bus.$emit('gelList');
							// $this.delinstance.instance.destroyUi()
							$this.delinstance = '';
							this.$emit('Delete');
						}, 500);
					}
					this.delinstance = '';
				})
				.catch((err) => {
					// lib.loadingChange($('.tableScope [loading]'), 'false')
					this.delinstance.w.hide();
					this.delinstance = '';
				});
		},
		deviceUpgrade (device) {
			if (!this.canBeClick) return;
			this.canBeClick = false;
			this.deviceTypess = device.deviceType;
			if (device.activationState == 1) {
				productInstructionsCheck({
					instructions: '2',
					productKey: this.deviceDetail.productId
				}).then(
					(res) => {
						if (res) {
							this.getListName(device);
						} else {
							this.canBeClick = true;
							this.$notify(
								getLanguageStr(
									'phrase653',
									'暂未开通设备升级功能'
								)
							);
						}
					},
					(error) => {
						this.$notify(error);
					}
				);
			} else {
				this.$notify(
					getLanguageStr(
						'device25',
						'设备还没有数据上传记录，请确认上电并成功连接服务器后重试。'
					)
				);
			}
		},
		// 获取固件升级名
		getListName (device) {
			orderFirmwareListCode(this.deviceDetail.productId).then(
				(res) => {
					// if (res.length) {
					device.productId =
						device.productId || this.deviceDetail.productId;
					this.$dynamic(
						this.$refs.view,
						DeviceUpgrade,
						{deviceType: this.deviceTypess},
						{showOrderRecord: [this.showOrderRecord.bind(this)]},
						{}
					).then(({instance, childInstance}) => {
						setTimeout(() => {
							this.canBeClick = true;
						}, 1000);
						childInstance.show(device, res, instance);
					});
					// this.$refs.DeviceUpgrade.show(device, res)
					// } else {
					//   this.$notify(getLanguageStr('phrase653', '暂未开通设备升级功能'))
					// }
				},
				(error) => {
					!_.isEmpty(error) && this.$notify(error);
					return false;
				}
			);
		},
		// 查看所属系统
		showStation (device) {
			if (!this.canBeClick) return;
			this.canBeClick = false;
			let buttonPermissions = localStorage.getItem('buttonPermissions');
			if (buttonPermissions.includes('B/A/A2')) {
				if (device.activationState == 1) {
					this.viewDetailOpen = true;
					this.$nextTick(() => {
						setTimeout(() => {
							this.canBeClick = true;
						}, 1000);
						this.$refs.ChooseStation.show(device);
						// this.$dynamic($(this.$el).parents("#app").find(".frame-main section").first()[0],PlantDetail,{
						// 	bg:true,
						// 	// outRoleCode:data.roleCode||this.roleCode
						// },{
						// 	Delete:[this.deletes.bind(this)]
						// },{}).then(({instance,childInstance})=>{
						// 	childInstance.show({id:device.siteId},instance);
						// });
					});
				} else {
					this.$notify(
						getLanguageStr(
							'device25',
							'设备还没有数据上传记录，请确认上电并成功连接服务器后重试。'
						)
					);
				}
			} else {
				this.$notify(
					getLanguageStr(
						'plant145',
						'你没有权限，请联系本商家超级管理员开启'
					)
				);
			}
		},
		showOrderRecord (data) {
			this.SET_CURRENTINDEX(3);
			this.$nextTick(() => {
				this.$refs.ViewDetail.show(data, 'OperateRecord');
			});
		},
		// 升级
		deviceControl (device) {
			// console.log(device)
			if (!this.canBeClick) return;
			this.canBeClick = false;
			if (device.activationState == 1) {
				productInstructionsCheck({
					instructions: '1',
					productKey: this.deviceDetail.productId
				}).then(
					(res) => {
						if (res) {
							this.getCodeList(device);
						} else {
							this.canBeClick = true;
							this.$notify(
								getLanguageStr(
									'phrase652',
									'暂未开通设备控制功能'
								)
							);
						}
					},
					(error) => {
						this.$notify(error);
					}
				);
			} else {
				this.$notify(
					getLanguageStr(
						'device25',
						'设备还没有数据上传记录，请确认上电并成功连接服务器后重试。'
					)
				);
			}
		},
		openview (datas) {
			autoAssociate(datas)
				.then((data) => {
					maintainApi
						.StationBasicInfo(datas.siteId)
						.then((siteData) => {
							if (siteData.powerType === 'PV') {
								this.$dynamic(
									this.$refs.view,
									SiteDetail,
									{bg: true, hideB: false},
									{},
									{}
								).then(({instance, childInstance}) => {
									childInstance.show(
										{id: datas.siteId},
										instance
									);
								});
							} else {
								this.$dynamic(
									this.$refs.view,
									WindSiteDetail,
									{bg: true, hideB: false},
									{},
									{}
								).then(({instance, childInstance}) => {
									childInstance.show(
										{id: datas.siteId},
										instance
									);
								});
							}
						});
				})
				.catch((err) => {
					if (err.data.code === "STATION_NEED_AUTH") {
						this.$refs.watchSystem.show(datas);
					}
				});
		},
		// 时区
		mz (data) {
			return stage.time.timezoneMap[data].offset;
		},
		// 打开
		show (data, openTab, instance, deviceType, tabindex, showName) {
			if (lib.doPermissions('B/A/A5')) {
				if (this.currentIndex == 0 && this.$refs.Details) {
					// console.log(2222222222222)
					try {
						this.$refs.Details.setIndex();
					} catch (e) {}
				}

				if (!data.deviceId) data.deviceId = data.id; // 部分api依赖字段，手动补充
				if (!data.deviceSn) data.deviceSn = data.sn;

				// this.showName=data.name;
				this.deviceId = data.deviceId;
				this.deviceSn = data.deviceSn;

				if (!this.outRoleCode) this.option.outRoleCode = data.roleCode; // 优先使用固定传入的权限数据

				this.device = data;

				this.device.deviceSn = this.deviceSn;
				this.siteId = data.siteId || data.stationId;
				this.$refs.Window.loadStatusAction(true);
				if (instance || instance === 0) {
					this.instance = instance;
				}
				// console.log(data)
				if (deviceType) {
					this.deviceType = deviceType;
				}
				if (openTab) {
					this.btnGroup.map((item, index) => {
						if (item.ref == openTab) this.currentIndex = index;
					});
				} else {
					this.currentIndex = 0; // 默认打开第一个tab
				}
				if (tabindex) this.tabindex = tabindex;
				else this.tabindex = '';

				this.$refs.Window.show();
				this._getDeviceDetail(); // 系统头部信息
			} else {
				this.$notify(
					getLanguageStr(
						'phrase783',
						'你没有权限，请联系本商家超级管理员开启'
					)
				);
			}
		},
		refresh () {
			this.$refs.Window.loadStatusAction(true);
			this._getDeviceDetail(); // 系统头部信息
		},
		// 头部信息
		_getDeviceDetail () {
			let requestData = {
				deviceId: this.deviceId,
				siteId: this.type == 1 ? this.siteId : undefined,
				language: stage.languageId,
				needRealTimeDataFlag: true
			};
			deviceApi.getDeviceDetail(requestData).then(
				(res) => {
					this.showName = res.name;
					this.device.parDeviceId = res.parDeviceId;
					this.device.parDeviceSn = res.parDeviceSn;
					this.device.deviceType = res.type;
					this.device.activationState = res.activationState;
					if (this.device.activationState != 1) {
						this.$notify(
							getLanguageStr(
								'device25',
								'设备还没有数据上传记录，请确认上电并成功连接服务器后重试。'
							)
						);
						setTimeout(() => {
							this.$refs.Window.hide();
						}, 1000);

						return;
					}
					this.$refs.Window.loadStatusAction(false);
					// if (res) res.collectionTime = Number(res.collectionTime) + mz.tz(res.timeZone)._offset * 60
					this.deviceDetail = res || [];

					if (this.dynamic.linkInfoBox) { this.dynamic.linkInfoBox.destroyUi(); }
					this.$dynamic(
						this.$refs.linkInfoBox,
						LinkInfo,
						{
							type: this.type,
							timezone:
								this.deviceDetail.timeZone ||
								this.option.timeZoneCode,
							siteId: this.siteId,
							deviceId: this.deviceId,
							deviceSn: this.deviceSn
							// deviceType:this.deviceDetail.type
						},
						{},
						{}
					).then(({instance, childInstance}) => {
						this.dynamic.linkInfoBox = instance;
						this.dynamic.LinkInfo = childInstance;
						this.changeBtn(this.currentIndex); // 切换tab
					});
				},
				(error) => {
					this.$refs.Window.loadStatusAction(false);
					!_.isEmpty(error) && this.$notify(error);
					this.hide();
					return false;
				}
			);
		},
		changeBtn (index) {
			this.currentIndex = index;
			if (this.btnGroup[this.currentIndex].ref == 'Details') {
				this.$nextTick(() => {
					let deviceMap = {...this.deviceDetail, ...this.device};
					deviceMap.type = this.deviceDetail.type;
					deviceMap.collectionTime = this.deviceDetail.collectionTime;
					this.$refs.Details.show(deviceMap);
				});
			} else if (this.btnGroup[this.currentIndex].ref == 'AlarmInfo') {
				// 报警信息
				statistic('A68', 'A6823');
				this.$nextTick(() => {
					this.$refs.AlarmInfo.show();
				});
			} else if (this.btnGroup[this.currentIndex].ref == 'LinkInfo') {
				statistic('A68', 'A6828');
				this.$nextTick(() => {
					this.dynamic.LinkInfo.show();
				});
			} else if (this.btnGroup[this.currentIndex].ref == 'ReaderRecord') {
				this.$nextTick(() => {
					this.$refs.ReaderRecord.show({
						id: this.deviceId
					});
				});
			} else if (this.btnGroup[this.currentIndex].ref == 'UpdateRecord') {
				this.$nextTick(() => {
					this.$refs.UpdateRecord.show({
						deviceId: this.deviceId
					});
				});
			} else if (
				this.btnGroup[this.currentIndex].ref == 'OperateRecord'
			) {
				statistic('A68', 'A6829');
				this.$nextTick(() => {
					this.$refs.OperateRecords.show();
				});
			}
		},
		hide () {
			this.$refs.Window.hide();
		},
		myClose () {
			setTimeout(() => {
				if (this.instance) {
					this.instance.destroyUi();
				} // 电站详情下面的子系统（ChildSysTable.vue）点击viewDetail中instance的传值为''
				this.instance = null;
				// this.$bus.$emit('closeVdetail', this.instance)
				this.currentIndex = 0;
			}, 500);
		},
		// 获取指令列表，无指令列表则不显示
		getCodeList (device) {
			apiGetAvailableOrder(
				this.deviceDetail.productId,
				this.deviceDetail.deviceId
			).then(
				(res) => {
					if (
						res.batch.isExist ||
						res.single.length ||
						res.customize
					) {
						device.productId =
							device.productId || this.deviceDetail.productId;

						this.canBeClick = true;
						this.$dynamic(
							this.$refs.view,
							DeviceControl,
							{},
							{},
							{}
						).then(({instance, childInstance}) => {
							setTimeout(() => {
								this.canBeClick = true;
							}, 1000);
							childInstance.show(device, res, '', instance);
						});
					} else {
						this.canBeClick = true;
						this.$notify(
							getLanguageStr('phrase652', '暂未开通设备控制功能')
						);
						// this.getOpenStatus(device, res)
					}
				},
				(error) => {
					!_.isEmpty(error) && this.$notify(error);
					return false;
				}
			);
		}
		// 查看是否存在自定义指令
		// getOpenStatus (device, resv) {
		// 	apiOpenStatus(this.deviceDetail.productId).then(res => {
		// 		if (!res) {
		// 			this.$notify(getLanguageStr('phrase652', '暂未开通设备控制功能'))
		// 		} else {
		// 			device.productId = device.productId || this.deviceDetail.productId
		// 			this.$dynamic(this.$refs.view, DeviceControl, {}, {}, {}).then(({ instance, childInstance }) => {
		// 				childInstance.show(device, resv, 1, instance)
		// 			})
		// 		}
		// 	})
		// }
	},
	mounted () {
		if (!this.timezone) {
			this.option.timeZoneCode = stage.time.timeZoneCode;
		} else {
			this.option.timeZoneCode = this.timezone;
		}
		let buttonPermissions = localStorage.getItem('buttonPermissions');
		let allTabs = [
			{
				title: getLanguageStr('word734', '详情'),
				ref: 'Details',
				permission: 'B/A/A5'
			},
			{
				title: getLanguageStr('word629', '报警信息'),
				ref: 'AlarmInfo',
				permission: 'B/A/A6'
			},
			{
				title: getLanguageStr('word1529', '连接信息'),
				ref: 'LinkInfo',
				permission: 'B/A/A7'
			},
			{
				title: getLanguageStr('word1660', '操作日志'),
				ref: 'OperateRecord',
				permission: 'B/A/A8'
			}
		];
		// ,{
		// 	title: getLanguageStr("控制日志","控制日志"),
		// 	ref:'ReaderRecord',
		// 	permission: 'B/A/A8'
		// },{
		// 	title: getLanguageStr("升级日志","升级日志"),
		// 	ref:'UpdateRecord',
		// 	permission: 'B/A/A9'
		// }
		let cloneB = _.cloneDeep(this.btnGroup);
		cloneB = [];
		this.btnGroup = [];
		allTabs.forEach((item) => {
			if (buttonPermissions.includes(item.permission)) cloneB.push(item);
		});
		this.btnGroup = cloneB;

		lib.fillHeight();
		lib.setScroll($(this.$el).find('[scroll]'));
	}
};
</script>
<style lang="scss" scoped>
//@import '~@/style/definition.scss';

.window > .body {
	padding-bottom: 0;
}
// .bgContent{background-color: $bgGray}
.head {
	background: #fff;
}
.statueIcon {
	vertical-align: middle;
	margin: -3px 5px 0 0;
}
.statueIcon :deep(.dvStatus) {
	width: 1.2em;
	height: 1.2em;
}
button::-moz-focus-inner {
	border: 0;
}
.dropList {
	background: #fff;
	width: 9em;
	left: -2em;
	a {
		color: #666;
		padding-right: 1em;
	}
	a:hover {
		background-color: rgba(0, 0, 0, 0.05);
		color: #ff595f;
	}
}
.pd0 {
	padding: 0 !important;
}
// .marks>span{padding:2px 8px;border-radius: 1em}
</style>



// WEBPACK FOOTER //
// src/view/device/operationalAudit/ViewDetail.vue